import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight, Eye, EyeOff, Loader2 } from "lucide-react";
import Logo from "@/components/Logo";
import { useOwner } from "@/components/admin/AdminContext";
import { adminApi, apiError } from "@/lib/blogApi";
import { inputCls } from "@/components/forms";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const { setUser } = useOwner();
  const navigate = useNavigate();
  const location = useLocation();
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { const { data } = await adminApi.post("/auth/login", { email, password }); setUser(data); navigate(location.state?.from?.startsWith("/admin/") ? location.state.from : "/admin/posts", { replace: true }); }
    catch (e) { setError(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <main className="min-h-screen hero-reference text-white px-4 py-12 flex flex-col items-center justify-center">
      <div className="w-full max-w-md">
        <Link to="/" data-testid="login-home-link" className="inline-flex items-center gap-2 text-sm text-slate-300 mb-10"><ArrowLeft size={16} />Back to website</Link>
        <Logo light testid="login-logo" />
        <h1 className="mt-9 font-display text-4xl font-semibold" data-testid="admin-login-title">Owner sign in</h1>
        <p className="mt-3 text-slate-300">Ferry Freight Journal</p>
        <form onSubmit={submit} className="mt-8 bg-white text-ink rounded-2xl p-6 sm:p-8 space-y-5" data-testid="admin-login-form">
          <label className="block text-sm font-semibold">Email address<input type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className={`${inputCls} mt-2`} data-testid="admin-email-input" /></label>
          <label className="block text-sm font-semibold">Password<div className="relative mt-2"><input type={show ? "text" : "password"} autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className={`${inputCls} pr-12`} data-testid="admin-password-input" /><button type="button" aria-label={show ? "Hide password" : "Show password"} onClick={() => setShow(!show)} className="absolute right-2 top-1 h-10 w-10 flex items-center justify-center text-slate-500" data-testid="admin-password-toggle">{show ? <EyeOff size={18} /> : <Eye size={18} />}</button></div></label>
          {error && <p role="alert" className="text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
          <button disabled={busy} className="btn-pill primary-action w-full px-5 py-3" data-testid="admin-login-submit">{busy ? <Loader2 className="animate-spin" size={16} /> : null}Sign in<ArrowRight size={16} /></button>
        </form>
      </div>
    </main>
  );
}